<cm-inspector-section>
    <ng-container cm-title> Target Statistics</ng-container>
    <ng-container cm-content>
        <div>
            <div class="cm-mode-tabs">
                <cm-button
                    class="cm-mode"
                    [class.cm-active]="$targetStatsMode() === targetStatsModes.ReferenceImage"
                    (click)="setTargetStatsMode(targetStatsModes.ReferenceImage)"
                    [disabled]="$disabled()"
                >
                    <ng-container cm-left-icon><i class="far fa-image"></i></ng-container>
                    <ng-container cm-text>Reference Image</ng-container>
                </cm-button>
                <cm-button
                    class="cm-mode"
                    [class.cm-active]="$targetStatsMode() === targetStatsModes.ColorPicker"
                    (click)="setTargetStatsMode(targetStatsModes.ColorPicker)"
                    [disabled]="$disabled()"
                >
                    <ng-container cm-left-icon><i class="far fa-palette"></i></ng-container>
                    <ng-container cm-text>Color Picker</ng-container>
                </cm-button>
            </div>
            <div class="cm-mode-content">
                @if ($computingTargetStats()) {
                    <div class="cm-reference-image-analyzing">
                        <cm-loading-spinner-icon></cm-loading-spinner-icon>
                        <span class="cm-label">Computing target color statistics…</span>
                    </div>
                } @else if ($targetStatsMode() === targetStatsModes.ReferenceImage) {
                    <cm-hint>
                        <ng-container cm-text>Drop a reference image here to compute target color statistics from it.</ng-container>
                    </cm-hint>
                    <cm-drop-files
                        class="cm-reference-image-drop"
                        [mimeTypeFilter]="MimeType.Images"
                        [showDropzone]="true"
                        [enableDrop]="!$disabled()"
                        [maxFiles]="1"
                        subtitle="or click to browse"
                        (filesDropped)="onReferenceImageDropped($event)"
                    ></cm-drop-files>
                } @else {
                    <cm-hint>
                        <ng-container cm-text>Pick a target color to compute target color statistics from it.</ng-container>
                    </cm-hint>
                    <div class="cm-color-picker-wrapper" [class.cm-disabled]="$disabled()">
                        <cm-color-input (valueChange)="onColorPicked($event)"></cm-color-input>
                    </div>
                }
            </div>
        </div>
        @if ($isDebugEnabled()) {
            <div class="cm-stats-grid">
                <span></span>
                <span class="cm-label">Mean</span>
                <span class="cm-label">Std. Dev.</span>

                <span class="cm-label">L</span>
                <cm-input-container>
                    <ng-container cm-input>
                        <cm-numeric-input
                            [value]="$targetMeanL()"
                            (valueChange)="setTargetMeanL($event)"
                            [decimalPlaces]="2"
                            [disabled]="$disabled()"
                        ></cm-numeric-input>
                    </ng-container>
                </cm-input-container>
                <cm-input-container>
                    <ng-container cm-input>
                        <cm-numeric-input
                            [value]="$targetStddevL()"
                            (valueChange)="setTargetStddevL($event)"
                            [decimalPlaces]="2"
                            [disabled]="$disabled()"
                        ></cm-numeric-input>
                    </ng-container>
                </cm-input-container>

                <span class="cm-label">a</span>
                <cm-input-container>
                    <ng-container cm-input>
                        <cm-numeric-input
                            [value]="$targetMeanA()"
                            (valueChange)="setTargetMeanA($event)"
                            [decimalPlaces]="2"
                            [disabled]="$disabled()"
                        ></cm-numeric-input>
                    </ng-container>
                </cm-input-container>
                <cm-input-container>
                    <ng-container cm-input>
                        <cm-numeric-input
                            [value]="$targetStddevA()"
                            (valueChange)="setTargetStddevA($event)"
                            [decimalPlaces]="2"
                            [disabled]="$disabled()"
                        ></cm-numeric-input>
                    </ng-container>
                </cm-input-container>

                <span class="cm-label">b</span>
                <cm-input-container>
                    <ng-container cm-input>
                        <cm-numeric-input
                            [value]="$targetMeanB()"
                            (valueChange)="setTargetMeanB($event)"
                            [decimalPlaces]="2"
                            [disabled]="$disabled()"
                        ></cm-numeric-input>
                    </ng-container>
                </cm-input-container>
                <cm-input-container>
                    <ng-container cm-input>
                        <cm-numeric-input
                            [value]="$targetStddevB()"
                            (valueChange)="setTargetStddevB($event)"
                            [decimalPlaces]="2"
                            [disabled]="$disabled()"
                        ></cm-numeric-input>
                    </ng-container>
                </cm-input-container>
            </div>
        }
    </ng-container>
</cm-inspector-section>
<cm-inspector-section>
    <ng-container cm-title> Adjustments</ng-container>
    <ng-container cm-content>
        <div>
            <span class="cm-label">Luminance</span>
            <cm-slider [min]="0" [max]="1" [value]="$luminance()" (valueChange)="setLuminance($event)" [disabled]="$disabled()"></cm-slider>
        </div>
        <div>
            <span class="cm-label">Color Intensity</span>
            <cm-slider [min]="0" [max]="1" [value]="$colorIntensity()" (valueChange)="setColorIntensity($event)" [disabled]="$disabled()"></cm-slider>
        </div>
        <div>
            <span class="cm-label">Fade</span>
            <cm-slider [min]="0" [max]="1" [value]="$fade()" (valueChange)="setFade($event)" [disabled]="$disabled()"></cm-slider>
        </div>
    </ng-container>
</cm-inspector-section>
